//
//
//
//
//
//
//
//
import TabBar from "@/components/public/TabBar";
import OfficeCardNeed from "@/components/officeCard/OfficeCardNeed";
import OfficeCardDone from "@/components/officeCard/OfficeCardDone";
import OfficeCardLaunch from "@/components/officeCard/OfficeCardLaunch";
export default {
  name: "OfficeCard",
  components: {
    TabBar: TabBar,
    OfficeCardNeed: OfficeCardNeed,
    OfficeCardDone: OfficeCardDone,
    OfficeCardLaunch: OfficeCardLaunch
  },
  props: [],
  data: function data() {
    return {
      active: "OfficeCardNeed",
      tabData: [{
        index: "OfficeCardNeed",
        name: "待处理"
      }, {
        index: "OfficeCardDone",
        name: "已处理"
      }, {
        index: "OfficeCardLaunch",
        name: "我发起"
      }]
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};